let cmmNewHDHostingDisableFeatures = false;
let cmmHDHostingChange = true;

enum CMMLogLevel {
  EMERGENCY = 0,
  ALERT,
  CRITICAL,
  ERROR,
  WARNING,
  NOTICE,
  INFO,
  DEBUG,
}
interface CMMLog {
  message: string;
  component: string;
  severity: CMMLogLevel;
  program?: string;
}
function cmm_log_data(sendData: CMMLog) {
  var http = new XMLHttpRequest();
  var url = 'https://logs.api.creekmoremarketing.com/logs.php';

  sendData.program = 'HDSites';

  if (sendData.message) {
    sendData.message = sendData.message + ' [' + window.location.href + ']';
  }

  http.open('POST', url, true);

  http.setRequestHeader('Content-type', 'application/json');

  http.onreadystatechange = function () {
    if (http.readyState == 4 && http.status == 200) {
      //data sent successfully
    }
  };
  http.send(JSON.stringify(sendData));
}

let CMM_IS_INTERNAL: Promise<boolean> = null;
/**
 * Wrapper for localStorage data on assets.creekmoremarketing.com
 */
function cmmCheckInternal(is_internal: boolean = false): Promise<boolean> {
  if (CMM_IS_INTERNAL === null) {
    CMM_IS_INTERNAL = new Promise<boolean>((resolve, reject) => {
      if (window.location.search.indexOf('cmm-external') > -1) {
        resolve(false);
        return;
      }

      const CMM_MESSAGE_WINDOW = document.createElement('iframe');
      CMM_MESSAGE_WINDOW.style.display = 'none';
      window.addEventListener(
        'message',
        (event) => {
          if (event.origin !== 'https://assets.creekmoremarketing.com') {
            //message was for some other system
            return;
          }

          let message = event.data;
          if (message == 'true') {
            resolve(true);
          } else {
            resolve(false);
          }

          CMM_MESSAGE_WINDOW.remove();
        },
        false,
      );
      CMM_MESSAGE_WINDOW.onload = function () {
        if (is_internal) {
          resolve(true);
          CMM_MESSAGE_WINDOW.contentWindow.postMessage(
            'is_internal',
            'https://assets.creekmoremarketing.com',
          );
        } else {
          CMM_MESSAGE_WINDOW.contentWindow.postMessage(
            'check',
            'https://assets.creekmoremarketing.com',
          );
        }
      };
      CMM_MESSAGE_WINDOW.onerror = function () {
        reject();
      };
      CMM_MESSAGE_WINDOW.src =
        'https://assets.creekmoremarketing.com/cmm-assets-localstorage.html';
      document.body.appendChild(CMM_MESSAGE_WINDOW);
    });
  }

  return CMM_IS_INTERNAL;
}
function cmmIfInternal(func: () => void) {
  return cmmCheckInternal().then((isInternal) => {
    if (!isInternal) return;
    func();
  });
}
cmmCheckInternal(window.location.search.indexOf('cmm-internal') > -1).then(
  (isInternal) => {
    if (isInternal) {
      console.warn('CMM: Internal Traffic User ');

      // set as internal traffic for tracking
      gtag('set', {
        traffic_type: 'internal',
      });

      document.body.classList.add('cmm-internal-user');
    }
  },
);

//save errors to Creekmore Logging
window.addEventListener('error', function (e) {
  if (e.filename.includes('assets.creekmoremarketing.com')) {
    cmm_log_data({
      message: 'JS Error: ' + e.message,
      component: 'HD_JS_Assets',
      severity: CMMLogLevel.ERROR,
    });
  }
});

function loadFileErrorCMM(elem: any, oError: any) {
  if (!oError) oError = elem;

  cmm_log_data({
    message:
      'File Load Error: ' +
      ((oError.target as HTMLImageElement).src ||
        (oError.target as HTMLAnchorElement).href),
    component: 'HD_JS_Assets',
    severity: CMMLogLevel.ERROR,
  });
}

/**
 * Loads a script tag onto the page
 *
 * @param url - URL of the script resource
 * @param vars - any URL parameters for the script
 * @param attributes - any additional tag attributes needed (e.g. id, class, data)
 * @param callback - function to execute when the script loads
 */
function loadScriptCMM(
  url: string,
  vars: string = '',
  attributes: { [key: string]: any } = null,
  callback: (...argc: any[]) => any = null,
): Promise<HTMLScriptElement> {
  return new Promise((resolve, reject) => {
    var script = document.createElement('script');

    var args = '';
    if (vars) {
      args = `?${vars}`;
    }

    if (attributes) {
      Object.keys(attributes).forEach((attr) => {
        if (script.hasOwnProperty(attr)) {
          script[attr] = attributes[attr];
        }
        script.setAttribute(attr, attributes[attr]);
      });
    }

    script.onload = () => {
      if (typeof callback === 'function') {
        callback();
      }
      resolve(script);
    };

    script.onerror = () => {
      reject(script);
    };

    script.src = url + args;
    document.head.appendChild(script);

    // Automatically add 'cmm-podium' to body for sites that use Podium
    if (url.includes('connect.podium.com')) {
      document.body.classList.add('cmm-podium');
    }
  });
}
/**
 * @deprecated Use "loadScriptCMM" instead
 */
let loadScriptHDID = function (
  url: string,
  vars: string = '',
  isAsync: boolean = false,
  callback: (...argc: any[]) => any = null,
) {
  //deprecated; log what sites are using the old methods
  cmm_log_data({
    message: 'Deprecated: loadScriptHDID',
    component: 'HD_JS_Assets',
    severity: CMMLogLevel.WARNING,
  });
  var attributes = {};
  if (isAsync) attributes = { async: isAsync };
  loadScriptCMM(url, vars, attributes, callback);
};
/**
 * @deprecated Use "loadScriptCMM" instead
 */
let loadScript = function (
  url: string,
  vars: string = '',
  isAsync: boolean = false,
) {
  //deprecated; log what sites are using the old methods
  cmm_log_data({
    message: 'Deprecated: loadScript',
    component: 'HD_JS_Assets',
    severity: CMMLogLevel.WARNING,
  });
  var attributes = {};
  if (isAsync) attributes = { async: isAsync };
  loadScriptCMM(url, vars, attributes);
};

function loadStyleCMM(url: string, vars: string = '') {
  var args = '';
  if (vars) {
    args = '?' + vars;
  }

  var style = document.createElement('link');
  style.rel = 'stylesheet';
  style.href = url + args;
  style.onerror = loadFileErrorCMM;
  document.head.appendChild(style);
}
/**
 * @deprecated Use "loadStyleCMM" instead
 */
let loadStyleHDID = function (url: string, vars: string = '') {
  //deprecated; log what sites are using the old methods
  cmm_log_data({
    message: 'Deprecated: loadStyleHDID',
    component: 'HD_JS_Assets',
    severity: CMMLogLevel.WARNING,
  });
  loadScriptCMM(url, vars);
};
/**
 * @deprecated Use "loadStyleCMM" instead
 */
let loadStyle = function (url: string, vars: string) {
  //deprecated; log what sites are using the old methods
  cmm_log_data({
    message: 'Deprecated: loadStyle',
    component: 'HD_JS_Assets',
    severity: CMMLogLevel.WARNING,
  });
  loadStyleCMM(url, vars);
};

(window as any).URLSearchParams =
  (window as any).URLSearchParams ||
  function () {
    this.get = function () {
      return null;
    };
  };
var cmmURLParams = new URLSearchParams(window.location.search);
var cmmAllDisabled =
  cmmURLParams.get('cmm-disable') !== null &&
  (cmmURLParams.get('cmm-disable') === '' ||
    cmmURLParams.get('cmm-disable') === '1' ||
    cmmURLParams.get('cmm-disable').toLowerCase() === 'true');
if (
  window.location.hostname === 'author-huntdougnj-prod.adobemsbasic.com' ||
  window.location.hostname === 'author-hunterd-prd65.adobecqms.net' ||
  window.location.hostname === 'dev.beta.hdwfdealer.com' ||
  window.location.hostname.endsWith('vercel.app') ||
  window.location.hostname === 'localhost'
) {
  cmmAllDisabled = true; //disable in editors
}

if (!cmmAllDisabled) {
  var cmmSiteID = window.location.hostname;

  let platformSuffix = '';
  if ((window as any).__next_f) {
    platformSuffix = '-sanity';

    cmm_log_data({
      message: 'Site using Sanity platform',
      component: 'HD_Platform',
      severity: CMMLogLevel.WARNING,
    });
  }

  if (typeof (window as any).loadedStyles == 'undefined') {
    loadStyleCMM(
      `//assets.creekmoremarketing.com/master-hd${platformSuffix}.min.css`,
    );
    loadStyleCMM(
      '//assets.creekmoremarketing.com/' + cmmSiteID.trim() + '/style.min.css',
    );
  }
  (window as any).loadedStyles = true;

  var d = new Date();
  var n = d.getTime();
  n = 0;
  if (typeof (window as any).loadedScripts == 'undefined') {
    loadScriptCMM(
      'https://ajax.googleapis.com/ajax/libs/jquery/3.5.1/jquery.min.js',
      null,
      { defer: true, crossorigin: 'anonymous' },
      function () {
        loadScriptCMM(
          `//assets.creekmoremarketing.com/master-hd${platformSuffix}.min.js`,
          null,
          { defer: true, crossorigin: 'anonymous' },
          function () {
            loadScriptCMM(
              '//assets.creekmoremarketing.com/' +
                cmmSiteID.trim() +
                '/main.min.js',
              null,
              { defer: true, crossorigin: 'anonymous' },
              function () {
                if (typeof (window as any).sendCMMTimestamp === 'function') {
                  (window as any).sendCMMTimestamp();
                }
              },
            );
          },
        );
      },
    );
  }
  (window as any).loadedScripts = true;
}
